import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {person,personModel } from "../../model/personModel";
declare var FB: any;


@Component({
    selector: 'person-profile',
    templateUrl: 'personPage.html'
})
export class personPage {    
    genderType: Array<string> = ['Male', 'Female', 'TransGender'];
    bloodGroupType: Array<string> = ['A+', 'A-', 'B+','B-','o+','o-','AB+','AB-'];
    constructor(
        public personProfile: personModel,
        public navCtrl: NavController
    ) {
        
        //this.personProfile.me.gender = this.genderType[0];
    }
    save() {
        this.personProfile.update();
        console.log(this.personProfile);
        this.navCtrl.pop();
    }
    checkLoginState() {
        var that = this;
        FB.getLoginStatus(function (response) {
            that.statusChangeCallback(response);
        });
    }
    statusChangeCallback(response) {
        console.log(response);
    }
}





// WEBPACK FOOTER //
// ./src/pages/person/person.ts